<template lang="html">
  <div>
    <!-- List Row -->
    <v-layout row class="mt-3">

      <v-flex v-if="isDownloadingContent" xs12 class="text-xs-center fs-larger">
        A carregar conteúdos
      </v-flex>

      <v-flex v-else-if="!contentArray || contentArray.length < 1" xs12 class="text-xs-center fs-larger">
        Sem conteúdos
      </v-flex>

      <v-flex v-else xs12>

        <v-card>
          <v-list two-line>

            <template v-for="(content, index) in contentArray" :keys="index">
              <!-- <v-subheader
                v-if="item.header"
                :key="item.header"
              >
                {{ item.header }}
              </v-subheader> -->

              <!-- <v-divider
                v-else-if="item.divider"
                :key="index"
                :inset="item.inset"
              ></v-divider> -->

              <v-list-tile
                :key="content.id"
                avatar
                @click="openContent(content)"
              >

                <v-list-tile-content>

                  <v-layout w-100 align-center>
                    <!-- Left -->
                    <v-flex grow>
                      <v-list-tile-title v-html="content.niceName"></v-list-tile-title>
                      <!-- <v-list-tile-sub-title v-html="content.key"></v-list-tile-sub-title> -->
                    </v-flex>
                    <!-- Right -->
                    <v-flex shrink>
                      <!-- <v-layout row>
                        <div @click="openAlbum(album, 'en')" class="mr-2">EN</div>
                        <div @click="openAlbum(album, 'es')">ES</div>
                      </v-layout> -->
                    </v-flex>
                  </v-layout>

                </v-list-tile-content>
              </v-list-tile>

            </template>
          </v-list>
        </v-card>

      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  created: function () {
    this.getContent()
  },
  data: function () {
    return {
      isDownloadingContent: false
    }
  },
  computed: {
    ...mapGetters([
      'getContentArray'
    ]),
    contentArray: function () {
      return this.getContentArray
    }
  },
  methods: {
    ...mapActions([
      'downloadContent'
    ]),
    getContent: function () {
      this.isDownloadingContent = true
      this.downloadContent().then(()=>{
        this.isDownloadingContent = false
      })
    },
    openContent: function (content) {
      this.$router.push({ name: 'ContentView', params: { contentId: content.id, content: content } })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
